import { Dropdown } from 'react-bootstrap';
import PropTypes from 'prop-types';
import {
  FaEdit,
  FaEllipsisV,
  FaEye,
  FaFile,
  FaListAlt,
  FaUser,
  FaExchangeAlt,
  FaChartLine,
  FaTrash // Importez l'icône de suppression
} from 'react-icons/fa';
import { getCurrentUserRole } from '../../../service/api/AuthRoleService';

const SecurityActionsDropdown = ({
  security,
  onViewDetails,
  onEditPrice,
  onViewHolders,
  onCreateTransaction,
  onGenerateDocuments,
  onViewTransactionDetails,
  onViewStatistics,
  onDeleteSecurity // Nouvelle prop pour la suppression
}) => {
  // Utilisez la fonction synchrone ici
  const role = getCurrentUserRole();
  
  const isPublic = security.targetMarket === 'Public';
  const isPrivate = security.targetMarket === 'Private';
  
  // Vérification des permissions
  const canEditPrice = role === 'admin' || role === 'admin+manager';
  const canDelete = role === 'admin' || role === 'admin+manager'; // Mêmes permissions pour suppression

  return (
    <Dropdown align="end" drop="start">
      <Dropdown.Toggle
        as="button"
        className="btn btn-sm btn-outline-primary border rounded-3 shadow-sm"
      >
        <FaEllipsisV />
      </Dropdown.Toggle>

      <Dropdown.Menu className="shadow-sm">
        <Dropdown.Item onClick={() => onViewDetails(security.securityId)}>
          <FaEye className="me-2 text-primary" />
          Voir détails
        </Dropdown.Item>

        {(isPublic || isPrivate) && (
          <Dropdown.Item onClick={() => onViewHolders(security)}>
            <FaUser className="me-2 text-warning" />
            {isPublic ? 'Voir les Porteurs' : 'Voir les Nominatifs'}
          </Dropdown.Item>
        )}

        {isPrivate && (
          <>
            <Dropdown.Item onClick={() => onCreateTransaction(security)}>
              <FaExchangeAlt className="me-2 text-purple" />
              Nouvelle transaction
            </Dropdown.Item>

            <Dropdown.Item onClick={() => onViewTransactionDetails(security)}>
              <FaListAlt className="me-2 text-info" />
              Détails des Transactions
            </Dropdown.Item>

            <Dropdown.Item onClick={() => onViewStatistics(security)}>
              <FaChartLine className="me-2 text-success" />
              Analyses Statistiques
            </Dropdown.Item>

            {onGenerateDocuments && (
              <Dropdown.Item onClick={() => onGenerateDocuments(security)}>
                <FaFile className="me-2 text-secondary" />
                Télécharger Documents (PDFs)
              </Dropdown.Item>
            )}
          </>
        )}

        {/* Options d'administration - UNIQUEMENT pour admin/admin+manager */}
        {(canEditPrice || canDelete) && (
          <>
            <Dropdown.Divider />
            
            {canEditPrice && (
              <Dropdown.Item 
                onClick={() => onEditPrice(security)}
                className="text-warning fw-bold"
              >
                <FaEdit className="me-2" />
                Modifier le prix
              </Dropdown.Item>
            )}
            
            {canDelete && onDeleteSecurity && (
              <Dropdown.Item 
                onClick={() => onDeleteSecurity(security.securityId)}
                className="text-danger fw-bold"
              >
                <FaTrash className="me-2" />
                Supprimer le titre
              </Dropdown.Item>
            )}
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

// Supprimez defaultProps et utilisez des paramètres par défaut
SecurityActionsDropdown.propTypes = {
  security: PropTypes.shape({
    securityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    targetMarket: PropTypes.oneOf(['Public', 'Private']).isRequired,
    securityName: PropTypes.string,
    symbol: PropTypes.string
  }).isRequired,
  onViewDetails: PropTypes.func.isRequired,
  onEditPrice: PropTypes.func.isRequired,
  onViewHolders: PropTypes.func.isRequired,
  onCreateTransaction: PropTypes.func.isRequired,
  onGenerateDocuments: PropTypes.func,
  onViewTransactionDetails: PropTypes.func.isRequired,
  onViewStatistics: PropTypes.func.isRequired,
  onDeleteSecurity: PropTypes.func // Nouvelle prop
};

// Définissez les valeurs par défaut dans les paramètres de fonction
const SecurityActionsDropdownWithDefaults = ({
  onGenerateDocuments = null,
  onDeleteSecurity = null, // Valeur par défaut
  ...props
}) => <SecurityActionsDropdown {...props} 
       onGenerateDocuments={onGenerateDocuments}
       onDeleteSecurity={onDeleteSecurity} 
     />;

export default SecurityActionsDropdownWithDefaults;